import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { PaymentService } from "../shared/services/payment.service";
import { PaymentRequest, MOMORequest } from "../shared/models/makepaymentReq";
import { PaymentDetails } from "../shared/models/paymentdetails";
import { USSDPaymentRes } from "../shared/models/ussdmakePaymentRes";
import { Router, ActivatedRoute } from "@angular/router";
import posthog from "posthog-js";

@Component({
  selector: "app-momo",
  templateUrl: "./momo.component.html",
  styleUrls: ["./momo.component.css"],
  standalone: false,
})
export class MOMOComponent implements OnInit, OnChanges {
  constructor(
    private router: ActivatedRoute,
    private payservice: PaymentService,
    private route: Router,
  ) {
    this.refereshLink = this.router.snapshot.params["payRef"];
  }
  refereshLink;
  ussdPaymentRequest = new PaymentRequest();
  // paymentDetails: PaymentDetails;
  banks = ["MTN", "AIRTEL"];
  selectedBank: string;
  bankName: string;
  paymentReference: string;
  ussdPaymentRes = new USSDPaymentRes();
  isBankAllowed: boolean = false;
  isProcessing: boolean = false;
  @Input() paymentDetails: PaymentDetails;
  @Output() isMakingPayment = new EventEmitter();
  paymentStatus = ["CREATED", "ONGOING", "ABANDONED", "FAILED", "SUCCESS"];
  message: string = "";
  timeSpent: number = 0;
  momoNumber: string;

  ngOnInit() {
    this.isBankAllowed = false;
    // this.getBanks();
    this.setPaymentDetails(this.paymentDetails);
    // this.showStatus();
  }

  ngOnChanges(changes) {
    this.paymentDetails = changes["paymentDetails"].currentValue;
    this.setPaymentDetails(this.paymentDetails);
  }

  //isMaking Payment
  // this is emmitted when there is need to disable other payment option during an ongoing payment.

  refereshPage() {
    this.isBankAllowed = false;
    // this.getBanks();
    this.bankName = "";
    this.isMakingPayment.emit("");
  }

  // getBanks() {
  //   this.payservice.getUssdBanks().subscribe((data) => {
  //     this.banks = data;
  //   });
  // }

  // Non-sensitive props shared by all momo analytics events.
  private momoEventProps() {
    return {
      provider: this.selectedBank,
      clientId: this.ussdPaymentRequest.clientId,
      amount: this.ussdPaymentRequest.amount,
      currency: this.ussdPaymentRequest.currency,
      reference: this.ussdPaymentRequest.reference,
    };
  }

  getBankUSSD() {
    this.isProcessing = true;
    this.ussdPaymentRequest["provider"] = this.selectedBank;
    this.ussdPaymentRequest.userId = this.momoNumber;

    posthog.capture("momo_payment_initiated", this.momoEventProps());

    this.payservice.makePayment(this.ussdPaymentRequest).subscribe(
      async (data: USSDPaymentRes) => {
        this.ussdPaymentRes = await { ...data };
        this.startTimer();
        // if (this.ussdPaymentRes.providerResponse) {
        //    this.isBankAllowed = true;
        // }
        if (this.ussdPaymentRes.status == "FAILED") {
          posthog.capture("momo_payment_failed", {
            ...this.momoEventProps(),
            status: this.ussdPaymentRes.status,
            stage: "initiation",
          });
          this.route.navigate([
            `/failure/${this.paymentDetails.amount}/${
              this.paymentDetails.referenceId
            }/${btoa(this.paymentDetails.callbackURL)}`,
          ]);
        } else {
          posthog.capture("momo_prompt_shown", {
            ...this.momoEventProps(),
            status: this.ussdPaymentRes.status,
          });
          this.isBankAllowed = true;
        }
        this.isProcessing = false;
      },
      (error) => {
        posthog.capture("momo_payment_error", {
          ...this.momoEventProps(),
          reason: error?.error?.responseMessage,
        });
        this.route.navigate([
          `/failure/${this.paymentDetails.amount}/${
            this.paymentDetails.referenceId
          }/${btoa(this.paymentDetails.callbackURL)}`,
        ]);
        this.isProcessing = false;
      },
    );
  }

  setPaymentDetails(details) {
    this.ussdPaymentRequest.reference = details.referenceId;
    this.ussdPaymentRequest.clientId = details.clientId;
    this.ussdPaymentRequest.amount = details.amount;
    this.ussdPaymentRequest.currency = "GHS"; // details.currency;
    this.ussdPaymentRequest.callbackUrl = details.callbackURL;
    this.ussdPaymentRequest.paymentChannel = "USSD";
    this.ussdPaymentRequest.userId = details.userId;
    this.ussdPaymentRequest.paymentUrl = details.paymentUrl;
  }

  generateUSSD() {
    this.isMakingPayment.emit("ussd");
    this.ussdPaymentRequest["provider"] = this.selectedBank;
    this.getBankUSSD();
  }

  setSelectedBank(e) {
    this.bankName = e;
    this.selectedBank = e;

    posthog.capture("momo_provider_selected", {
      provider: e,
      clientId: this.ussdPaymentRequest.clientId,
      amount: this.ussdPaymentRequest.amount,
      currency: this.ussdPaymentRequest.currency,
      reference: this.ussdPaymentRequest.reference,
    });
    // for (let a = 0; a < Object.keys(this.banks).length; a++) {
    //   if (Object.values(this.banks)[a]["Code"] == e) {
    //     this.bankName = Object.values(this.banks)[a]["name"];
    //   }
    // }
  }

  backGroundStatusCheck() {
    this.payservice
      .checkPaymentStatus(
        this.ussdPaymentRequest.clientId,
        this.ussdPaymentRequest.reference,
      )
      .subscribe(
        (data) => {
          this.setResponseMessage(data["status"]);
        },
        (error) => {
          // this.route.navigate([
          //   `/failure/${this.ussdPaymentRequest.reference}/${error.error.responseMessage}`,
          // ]);
          this.isProcessing = false;
          this.message = error.error.responseMessage;
          this.showStatus();
        },
      );
  }

  checkPaymentStatus() {
    this.isProcessing = true;

    posthog.capture("momo_status_check_clicked", this.momoEventProps());

    this.payservice
      .checkPaymentStatus(
        this.ussdPaymentRequest.clientId,
        this.ussdPaymentRequest.reference,
      )
      .subscribe(
        (data) => {
          this.setResponseMessage(data["status"]);
          this.isProcessing = false;
        },
        (error) => {
          // this.route.navigate([
          //   `/failure/${this.ussdPaymentRequest.reference}/${error.error.responseMessage}`,
          // ]);
          this.isProcessing = false;
          this.message = error.error.responseMessage;
          this.showStatus();
        },
      );
  }

  completeTxn() {
    // this.route.navigate([
    //   `/checkout/success/${this.ussdPaymentRequest.amount}/Completed`,
    // ]);
  }

  timeLeft: number = 30;
  interval = null;
  //used to check the payment status at interval
  //removed for resource management reasons
  //should there be a use, Kindly uncomment from the getussd iplementation
  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeSpent = this.timeSpent + 30;
        this.backGroundStatusCheck();
        this.timeLeft = 30;
      }
    }, 3000);
  }

  show = false;

  showStatus() {
    let contxt = this;
    this.show = true;
    setTimeout(function () {
      contxt.show = false;
      this.message = "";
      return;
    }, 3000);
  }

  setResponseMessage(response) {
    if (response == "ONGOING") {
      this.message = "Pending approval";
      this.showStatus();
      return;
    }
    if (response == "CREATED") {
      this.message = "Transaction yet to be started";
      // this.timeLeft = 50;
      this.showStatus();
      return;
    }
    // if (response == "ABANDONED") {
    //   this.route.navigate([`/failure/${this.refereshLink}/Abadoned`]);
    //   return;
    //   // clearInterval(this.interval);
    //   // this.isMakingPayment.emit("");
    // }
    if (response == "FAILED" || response == "ABANDONED") {
      posthog.capture("momo_payment_failed", {
        ...this.momoEventProps(),
        status: response,
        stage: "status_poll",
      });
      this.route.navigate([
        `/failure/${this.paymentDetails.amount}/${
          this.paymentDetails.referenceId
        }/${btoa(this.paymentDetails.callbackURL)}`,
      ]);
      // clearInterval(this.interval);
      // this.isMakingPayment.emit("bank");
    }
    if (response == "SUCCESS") {
      posthog.capture("momo_payment_successful", {
        ...this.momoEventProps(),
        status: response,
      });
      let callbackUrl = this.ussdPaymentRequest.callbackUrl
        ? this.ussdPaymentRequest.callbackUrl
        : "empty";
      this.route.navigate([
        `/checkout/success/${this.ussdPaymentRequest.amount}/${
          this.ussdPaymentRequest.reference
        }/${btoa(callbackUrl)}`,
      ]);
      // clearInterval(this.interval);
      return;
    } else {
      this.message = response;
      this.showStatus();
      return;
    }
  }
}
